import { Empty, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import type { AuditDiffEntry } from "../types";

/**
 * ⚠️ Satr qiymat XOM ko'rsatiladi, `JSON.stringify` siz — aks holda har
 * qiymat qo'shtirnoq ichida chiqib, `[maxfiy]` niqobi ham `"[maxfiy]"`
 * bo'lib o'qilishi qiyinlashardi. Qolgan turlar (obyekt, massiv, raqam,
 * `boolean`) chiroyli JSON bilan ochiladi.
 */
function formatQiymat(value: unknown): string {
	if (value === null || value === undefined) {
		return "—";
	}
	if (typeof value === "string") {
		return value;
	}

	return JSON.stringify(value, null, 2);
}

interface AuditDiffProps {
	diff: AuditDiffEntry[];
}

/**
 * `before`/`after` ni yonma-yon ko'rsatadi.
 *
 * ⚠️ **Faqat O'ZGARGAN maydonlar** — backend `diff` maydonida tayyor
 * beradi. To'liq obyekt 20 maydon ichidan bittasini qidirishga majbur
 * qilardi.
 *
 * ⚠️⚠️ **`[maxfiy]` niqobi KO'RINIB turadi va bu NORMAL.** U audit
 * jurnalida parol o'rniga nima yozilganini ko'rsatadi (poydevorning
 * `redactAudit()` i). Niqobni UI da yashirish yozuvni tushunarsiz
 * qilardi: maydon o'zgargan, lekin nimaga o'zgargani ko'rinmasdi.
 *
 * ⚠️ Bo'sh diff XATO EMAS: yaratish amalida `before` umuman yo'q, 1a dan
 * qolgan yozuvlarda ham shunday.
 */
export function AuditDiff({ diff }: AuditDiffProps) {
	const { t } = useTranslation("audit");

	if (diff.length === 0) {
		return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("diff.empty")} />;
	}

	const ustunlar: ColumnsType<AuditDiffEntry> = [
		{ title: t("diff.fieldColumn"), dataIndex: "field", key: "field", width: 200 },
		{
			title: t("diff.beforeColumn"),
			key: "before",
			render: (_, row) => (
				<pre className="!m-0 whitespace-pre-wrap">{formatQiymat(row.before)}</pre>
			),
		},
		{
			title: t("diff.afterColumn"),
			key: "after",
			render: (_, row) => <pre className="!m-0 whitespace-pre-wrap">{formatQiymat(row.after)}</pre>,
		},
	];

	return (
		<Table<AuditDiffEntry>
			columns={ustunlar}
			dataSource={diff}
			rowKey="field"
			size="small"
			pagination={false}
			scroll={{ x: "max-content" }}
		/>
	);
}
